<template>
  <div class="modal-wrapper" v-if="visible">
    <transition name="overlay">
      <div
        class="modal-overlay"
        v-show="delayedVisible"
        @click="overlayClose ? closeModal() : null"
        :style="overlayClose ? 'cursor: pointer' : 'cursor: default'"
      ></div>
    </transition>
    <transition name="modal">
      <div class="modal-container" v-show="delayedVisible">
        <div class="header">
          <h2>{{ currentVideo.name }}</h2>
          <div
            class="level"
            :style="`background-color: ${levelColors[currentVideo.level]}`"
          >{{ levels[currentVideo.level] }}</div>
        </div>
        <div class="video-container">
          <div
            @click="toggleVideoType()"
            class="toggle-video-type"
            :style="
              `background-color: ${
                currentVideoType === 'lesson' ? '#888' : '#f88'
              }`
            "
          >
            {{ currentVideoType === "lesson" ? "実践編" : "解説編" }}に切り替え
            <img
              v-show="currentVideoType === 'lesson'"
              src="@/assets/loop_2.svg"
            />
            <img v-show="currentVideoType === 'loop'" src="@/assets/class.svg" />
          </div>
          <video ref="video" oncontextmenu="return false;" class="video" controls="true">
            <source :src="selectedVideoUrl" type="video/mp4" height="100px" />
          </video>
        </div>
        <p class="guide">
          <span style="font-weight:bold">【解説】</span>
          {{ currentVideo.description }}
        </p>
        <ul>
          <li v-for="p in currentVideo.pron" :key="p">
            <router-link
              class="phoneme"
              :to="{ path: 'lesson', query: { category: p } }"
              :style="p === '(h)w' ? `font-size: 0.78rem` : `font-size: 1.1rem`"
            >{{ p }}</router-link>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import { db } from "@/plugins/firebase";

export default {
  props: {
    title: String,

    overlayClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      levels: ["基礎編", "発展編", "応用編"],
      levelColors: ["#888", "#f99", "#f66"],
      currentVideoType: "lesson",
      currentVideo: null,
      selectedVideoUrl: null,
      visible: false,
      delayedVisible: false
    };
  },
  async mounted() {},
  methods: {
    toggleVideoType() {
      if (this.currentVideoType === "lesson") {
        this.currentVideoType = "loop";
        this.$refs.video.src = this.currentVideo.urls.loop;
        this.$refs.video.loop = true;
      } else if (this.currentVideoType === "loop") {
        this.currentVideoType = "lesson";
        this.$refs.video.src = this.currentVideo.urls.lesson;
        this.$refs.video.loop = false;
      }
      this.$refs.video.play();
    },
    showModal(video) {
      this.currentVideo = video;
      this.selectedVideoUrl = video.urls.lesson;
      this.visible = true;
      setTimeout(() => {
        this.delayedVisible = true;
      }, 100);
    },
    closeModal() {
      this.delayedVisible = false;
      setTimeout(() => {
        this.visible = false;
      }, 500);
    },
    toggleModal() {
      this.visible = !this.visible;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  &-wrapper {
    z-index: 1400;
    position: fixed;
    width: 100vw;
    height: 100vh;
  }
  &-overlay {
    z-index: 1300;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.3);
  }

  &-container {
    background-color: #fff;
    z-index: 1301;
    width: 830px;
    height: 750px;
    box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.3);
    border-radius: 25px;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
  }
}
.header {
  display: flex;
  width: 790px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
}

h2 {
  font-size: 1.5rem;
  font-weight: 900;
  display: block;
  margin: 0;
  text-align: center;
}

.guide {
  margin: 0 20px;
}

video {
  width: 800px;
  min-height: 449.984px;
  outline: none;
}
.video-container {
  position: relative;
}

.toggle-video-type {
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1000;
  display: flex;
  color: white;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 6px 12px;
  font-size: 0.84rem;
  border-radius: 20px;
  img {
    width: 18px;
    height: 18px;
    margin-left: 4px;
  }
  &:hover {
    opacity: 0.9;
  }
}

.phoneme {
  height: 27px !important;
  width: 27px !important;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 50%; /* may require vendor prefixes */
  background: #eee;
  color: #555 !important;
  transition: all 0.2s ease;
  &:hover {
    background-color: $main-color;
    color: white !important;
    transform: scale(1.1);
  }
}

ul {
  margin: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.level {
  font-size: 0.89rem;
  font-weight: normal;
  color: white;
  border-radius: 13px;
  display: block;
  width: 70px;
  padding: 1px 1px;
  margin-bottom: 2px;
  text-align: center;
  align-self: flex-end;
  display: flex;
  justify-content: center;
  align-items: center;
}

// overlay animation

.overlay-enter-active,
.overlay-leave-active {
  transition: all 0.5s;
}
.overlay-enter,
.overlay-leave-to {
  opacity: 0;
}

// container animation

.modal-enter-active,
.modal-leave-active {
  transition: all 0.3s ease;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
  transform: scale(0.9);
}
</style>
